"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PIPE_INIT_WAIT_MAX_TIMEOUT_MS = exports.ContainerSessionService = exports.ContainerSessionChannel = void 0;
var ContainerSessionChannel;
(function (ContainerSessionChannel) {
    ContainerSessionChannel["Authorize"] = "/data-platform-proxy/csm/authorize";
    ContainerSessionChannel["Request"] = "/data-platform-proxy/csm/request";
    ContainerSessionChannel["Stream"] = "/data-platform-proxy/csm/stream";
})(ContainerSessionChannel || (exports.ContainerSessionChannel = ContainerSessionChannel = {}));
var ContainerSessionService;
(function (ContainerSessionService) {
    ContainerSessionService["ApiProxy"] = "/data-platform-proxy/csm";
})(ContainerSessionService || (exports.ContainerSessionService = ContainerSessionService = {}));
exports.PIPE_INIT_WAIT_MAX_TIMEOUT_MS = 120000;
